export class ViewportUtils {
  static scrollToElement(element?: JQuery<HTMLElement>, speed = 100, offset = 0) {
    if (!element) { return; }

    const nav_height = document.getElementById("navbar-container")?.offsetHeight || 0;

    $("html, body").animate({
      scrollTop: ((element.offset()?.top || 0) - nav_height - offset)
    }, speed);
  }
}

window.banco = window.banco || {};
window.banco.ViewportUtils = ViewportUtils;
